import React, { useEffect, useRef, useState } from "react";
import { fetchApi, getUploadsUrl } from "../../config";

export default function TrustedLogoTicker() {
    const [clients, setClients] = useState([]);
    const [repeatCount, setRepeatCount] = useState(1);
    const tickerRef = useRef(null);
    const groupRef = useRef(null);

    useEffect(() => {
        let mounted = true;
        async function load() {
            try {
                const res = await fetchApi("get_trusted_clients.php");
                if (!mounted) return;
                if (res && Array.isArray(res.TrustedClients)) {
                    setClients(res.TrustedClients);
                }
            } catch (err) {
                // keep empty on error
            }
        }
        load();
        return () => { mounted = false; };
    }, []);

    useEffect(() => {
        const ticker = tickerRef.current;
        const group = groupRef.current;
        if (!ticker || !group || !clients.length) return undefined;

        const updateRepeatCount = () => {
            const groupWidth = group.getBoundingClientRect().width;
            if (groupWidth > 0) {
                setRepeatCount(Math.max(1, Math.ceil(ticker.clientWidth / groupWidth)));
            }
        };

        updateRepeatCount();

        if (typeof ResizeObserver === "undefined") {
            window.addEventListener("resize", updateRepeatCount);
            return () => window.removeEventListener("resize", updateRepeatCount);
        }

        const observer = new ResizeObserver(updateRepeatCount);
        observer.observe(ticker);
        observer.observe(group);
        return () => observer.disconnect();
    }, [clients]);

    const items = clients.length ? clients : [];
    const renderSequence = (sequenceIndex) => (
        <div
            aria-hidden={sequenceIndex > 0 ? "true" : undefined}
            className="ticker-sequence"
            key={`sequence-${sequenceIndex}`}
        >
            {Array.from({ length: repeatCount }, (_, groupIndex) => (
                <div
                    aria-hidden={sequenceIndex === 0 && groupIndex > 0 ? "true" : undefined}
                    className="ticker-group"
                    key={`group-${sequenceIndex}-${groupIndex}`}
                    ref={sequenceIndex === 0 && groupIndex === 0 ? groupRef : undefined}
                >
                    {items.map((client) => (
                        <span key={client.id} className="client">
                            {client.featureimage_url ? (
                                <img
                                    src={getUploadsUrl('trusted_clients', client.featureimage_url)}
                                    alt={client.featureimage_name || client.name}
                                    loading="eager"
                                />
                            ) : (
                                client.name
                            )}
                        </span>
                    ))}
                </div>
            ))}
        </div>
    );

    return (
        <section className="container logos">
            <div className="label">TRUSTED BY TEAMS AT</div>
            <div className="ticker" ref={tickerRef}>
                <div
                    className="ticker-track"
                    style={{ animationDuration: `${28 * repeatCount}s` }}
                >
                    {renderSequence(0)}
                    {renderSequence(1)}
                </div>
            </div>
        </section>
    );
}